// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aHmV","col":"styles_col__3woCa"};